module.exports = __webpack_public_path__ + "static/media/personalHealthcare.a4d9b2df.svg";